var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"content"}},[_c('div',{attrs:{"id":"average"}},[_vm._v("平均度數 = "+_vm._s(_vm.average)+" kwh")]),_c('div',{attrs:{"id":"chart"}})])}
var staticRenderFns = []

export { render, staticRenderFns }